"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _styling = require("../../../toolkit/styling");

var _providers = require("../../../toolkit/providers");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ScaleIn = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(ScaleIn, _Component);

  var _super = _createSuper(ScaleIn);

  function ScaleIn() {
    var _this;

    (0, _classCallCheck2["default"])(this, ScaleIn);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(ScaleIn, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className;
      return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, this.props, {
        className: (0, _styling.css)(this.styles.root, className)
      }), children);
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$props$animation = this.props.animationDurationMs,
          animationDurationMs = _this$props$animation === void 0 ? 400 : _this$props$animation;
      var keyframes = {
        from: {
          transform: "scale(0, 0)",
          opacity: 0.5
        },
        to: {
          transform: "scale(1, 1)",
          opacity: 1
        }
      };
      return _aphrodite.StyleSheet.create({
        root: {
          ":nth-child(1n) > *": {
            transformOrigin: "center",
            animationName: [keyframes],
            animationDuration: "".concat(animationDurationMs, "ms")
          }
        }
      });
    }
  }]);
  return ScaleIn;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = {
  animationDurationMs: {
    required: false,
    defaultValue: "null",
    type: "?() => void",
    description: "How long the entrance animation should take in milliseconds"
  }
}, _class3.demoProps = {
  animationDurationMs: 400
}, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = ScaleIn;
exports["default"] = _default;